import { resolve, doorClient, ImResponse } from '.';

export interface QueryBlockListParams {
  platform: General.PlatformUpperCase;
  blacklistScope?: '1' | '2';
  storeIds?: number[];
  reasons?: string[];
  buyerNick?: string;
  operationNick?: string;
  remark?: string;
  buyerRegions?: General.UpperCaseRegion[];
  operationStartTime?: number;
  operationEndTime?: number;
  page: {
    pageNo: number;
    pageSize: number;
  };
  sort?: {
    field: 'OPERATION_TIME';
    order: 'asc' | 'desc';
  };
}

export interface BlockListItem {
  id: number;
  orgId: number;

  // 拉黑范围，1:全部店铺，2:单个店铺
  blacklistScope: 1 | 2;
  storeIds: number[];
  buyerId: string;
  buyerName: string;
  region: General.UpperCaseRegion;
  reason: string;

  // 备注
  remark: string;
  operationUserId: number;

  operationUserName: string;
  operationTime: number;
}

export interface BlockListConfig {
  orgId?: number;
  blacklistScope: 1 | 2;
  reasons: {
    reason: string;
    language: General.SystemLanguage;
  }[];
  customReasons?: string[];

  // 自动拉黑条件 1:买家发送优惠卡片 2:买家发送店铺
  autoBlacklistRule?: number[];
}

// eslint-disable-next-line import/prefer-default-export
export function queryBlockList(params: QueryBlockListParams): Promise<{
  total: number;
  msg: string;
  code: number;
  data: BlockListItem[];
}> {
  return doorClient
    .post<any>(`overseaim-hi-manager/orgBuyerBlacklist/v1/query`, {
      ...params,
    })
    .then((res) => {
      return res.data;
    });
}

export function getBlockListConfig(): Promise<BlockListConfig> {
  return resolve(doorClient.get('overseaim-hi-manager/orgBuyerBlacklistConfig/v1/get'));
}
export function updateBlockListConfig(params: Partial<BlockListConfig>) {
  return resolve(
    doorClient.put('overseaim-hi-manager/orgBuyerBlacklistConfig/v1/update', {
      ...params,
    }),
  );
}

interface AddBlockBuyerParam {
  buyerId: string;
  // 拉黑范围，1:全部店铺，2:单个店铺
  blacklistScope: 1 | 2;
  storeId: string;
  reason: string;
  remark?: string;
}
export function addBlockBuyer(params: AddBlockBuyerParam) {
  return resolve(
    doorClient.post<ImResponse<void>>('overseaim-hi-manager/orgBuyerBlacklist/v1/add', {
      ...params,
    }),
  );
}
interface RemoveFromBlockList {
  id: number;

  // 拉黑范围，1:全部店铺，2:单个店铺
  blacklistScope: 1 | 2;
  storeId: string;
}
export function removeFromBlockList(params: RemoveFromBlockList) {
  return resolve(
    doorClient.delete('overseaim-hi-manager/orgBuyerBlacklist/v1/delete', {
      data: {
        ...params,
        id: Number(params.id),
        storeId: params.storeId || undefined,
      },
    }),
  );
}
